export { default as Img200 } from './processed/200/ten.jpg';
export { default as Img400 } from './processed/400/ten.jpg';
export { default as Img600 } from './processed/600/ten.jpg';
export { default as Imgthumb } from './processed/thumb/ten.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/ten.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/ten.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      184,
      184,
      65
    ],
    "_population": 738,
    "_hsl": [
      0.16666666666666666,
      0.4779116465863454,
      0.48823529411764705
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      189,
      235
    ],
    "_population": 239,
    "_hsl": [
      0.8368794326241136,
      0.5529411764705884,
      0.8333333333333334
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      105,
      12,
      12
    ],
    "_population": 3,
    "_hsl": [
      0,
      0.7948717948717948,
      0.22941176470588234
    ]
  },
  "Muted": {
    "_rgb": [
      115,
      169,
      174
    ],
    "_population": 1689,
    "_hsl": [
      0.5141242937853108,
      0.2669683257918552,
      0.5666666666666667
    ]
  },
  "LightMuted": {
    "_rgb": [
      210,
      163,
      210
    ],
    "_population": 392,
    "_hsl": [
      0.8333333333333334,
      0.3430656934306569,
      0.7313725490196078
    ]
  },
  "DarkMuted": {
    "_rgb": [
      93,
      54,
      44
    ],
    "_population": 1720,
    "_hsl": [
      0.034013605442176874,
      0.35766423357664234,
      0.26862745098039215
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/ten.js